
// Import existing Database type from Supabase types
import { Database } from '@/integrations/supabase/types';

// Use the existing Database type definition to create our AppSettings type
export type AppSettings = Database['public']['Tables']['app_settings']['Row'];

// Create a default AppSettings object for initialization
export const defaultAppSettings: AppSettings = {
  id: 1,
  app_name: 'KFC Antilles',
  logo_url: '',
  favicon_url: '',
  social_preview_url: '',
  games_allowed_per_day: 3,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString()
};
